import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

const logoVariants = {
	hover: {
		scale: 1.5,
	},
	tap: {
		scale: 1.1,
	},
	transition: {
		duration: 0.5,
	},
};

const Logo = () => {
	const { openDrawer, setOpenDrawer } = useTheme();

	return (
		<Link
			to="/"
			className="min-h-[126px] relative p-2 flex items-center justify-center lg:left-48"
			onClick={() => setOpenDrawer(false)}>
			<motion.h1
				className="font-bold text-6xl text-green-800"
				variants={logoVariants}
				whileTap="tap"
				whileHover="hover"
				transition="transition">
				IBD.
			</motion.h1>
		</Link>
	);
};

export default Logo;
